import React from 'react';
export const useComputedChildrenWidth = () => {
    const [width, setWidth] = React.useState(null);
    const observer = React.useRef(null);
    const ref = React.useCallback((x) => {
        var _a;
        (_a = observer.current) === null || _a === void 0 ? void 0 : _a.disconnect();
        observer.current = null;
        if (!x) {
            return;
        }
        const measure = () => {
            let next = 0;
            for (let i = 0; i < x.children.length; ++i) {
                const y = x.children[i];
                next += y.getBoundingClientRect().width;
                next += parseFloat(window.getComputedStyle(y, null).marginLeft);
                next += parseFloat(window.getComputedStyle(y, null).marginRight);
            }
            setWidth((prev) => prev === next ? prev : next);
        };
        measure();
        observer.current = new ResizeObserver(measure);
        observer.current.observe(x);
    }, []);
    React.useEffect(() => {
        return () => {
            var _a;
            (_a = observer.current) === null || _a === void 0 ? void 0 : _a.disconnect();
        };
    }, []);
    return [ref, width];
};
export default useComputedChildrenWidth;
